import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Sem grupos de modificadores. Crie um novo.',
  fields: {
    name: 'Nome',
    external_id: 'Ref. {{integration}}',
    prices: 'Preços',
    available: 'Disponível',
    status: 'Estado',
    statuses: {
      good: 'Bom',
      bad: 'Mau',
      medium: 'Médio',
    },
  },
  order_method_prices: {
    base: 'Base',
    [ORDER_METHODS.pickup]: 'Takeaway',
    [ORDER_METHODS.delivery]: 'Entrega',
    [ORDER_METHODS.room_service]: 'Serviço de quarto/mesa',
  },
  labels: {
    visible: 'Visível no menu',
    hidden: 'Todos ocultos',
  },
  buttons: {
    add_modifier: 'Adicionar modificador',
    delete_modifier_one: 'Eliminar modificador',
    delete_modifier_other: 'Eliminar modificadores',
    show_modifier_group: 'Mostrar grupo de modificadores',
    close_modifier_group: 'Fechar grupo de modificadores',
    edit: 'Editar',
    duplicate: 'Duplicar',
    history: 'Histórico',
  },
  toasts: {
    failed_to_duplicate_modifier_group: 'Falha ao duplicar o grupo de modificadores',
    modifier_group_duplicated_successfully: 'Grupo de modificadores duplicado com sucesso',
    failed_to_duplicate_modifier: 'Falha ao duplicar o modificador',
    modifier_duplicated_successfully: 'Modificador duplicado com sucesso',
  },
};
